import { combineReducers } from 'redux';
import user from './user.reducer';

const reducer = combineReducers({
	user
});

export default reducer;
